// Polyfill
// import 'babel-polyfill'
// import 'utility/polyfills/closest'

// Globals
// import { ShowMediaLabel } from 'helpers/Globals'

// Helpers
// import ClickOutside from 'helpers/ClickOutside'

// Components
import Loader from 'components/loader/Loader'
import MobileNav from 'components/mobileNav/MobileNav'

// last...
import 'focus-visible'
import Embed from 'components/embed/Embed'
import PriorityNav from 'components/priority-nav/PriorityNav'
import Header from 'components/header/Header'
import TvgHeader from 'components/header/TvgHeader'
import Forms from 'components/forms/Forms'
import TransferOrders from 'components/transfer-orders/TransferOrders'
import Filter from 'components/filter/Filter'
import TvgImageGallery from 'components/tvg-image-gallery/TvgImageGallery'
import StoryBlock from 'components/story-block/StoryBlock'
import ArticleSwiper from 'components/article-swiper/ArticleSwiper'
import ArticlesLoadMore from 'components/articles-load-more/ArticlesLoadMore'
import ServiceBlock from 'components/service-block/ServiceBlock'
import RateRequest from 'components/rate-request/RateRequest'
import TvgContactForm from 'components/tvg-contact-form/TvgContactForm'
import TvgServices from 'components/tvg-services/TvgServices'
import TvgReveal from 'components/tvg-reveal/TvgReveal'
import TvgHero from 'components/tvg-hero/TvgHero'

const App = {
	init: () => {
		// Always first...
		Loader.init()

		// Components
		MobileNav.init()
		Embed.init()
		Header.init()
		TvgHeader.init()
		PriorityNav.init()
		// Before the blocks that wait for their parts to be revealed
		TvgReveal.init()
    Forms.init()
    Filter.init()
    TransferOrders.init()
    TvgImageGallery.init()
    StoryBlock.init()
    ArticleSwiper.init()
    ArticlesLoadMore.init()
    ServiceBlock.init()
    RateRequest.init()
    TvgContactForm.init()
    TvgServices.init()
    TvgHero.init()
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => App.init())
}
else {
	App.init()
}
